import './jquery'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import cssVars from 'css-vars-ponyfill'
import Constants from './const'
import Logger from './assets/scripts/logger.js'

Vue.config.productionTip = false;

Vue.use(VueCookie);
Vue.use(Constants);
Vue.use(Logger);

Vue.mixin({
	computed: {
		mxnIsLessonDataValid() {
			return this.$root.lessonData.name.length > 0 && this.$root.lessonData.organisation;
		},
		mxnIsMobileDevice() {
			return this.$root.device.mobile;
		}
	},
	methods: {
		mxnSubtitleMenuLabels() {
			var labels = {};
			labels.off = this.$t("videoPlayer.textSubtitlesOff");
			// TODO: need to change availableLocales to include country code, e.g. de-DE
			for (var i=0; i < this.$i18n.availableLocales.length; i++) {
				switch (this.$i18n.availableLocales[i]) {
					case "de":
						labels[this.$i18n.availableLocales[i] + "-DE"] = this.$t("language." + this.$i18n.availableLocales[i]);
						break;
					case "en":
						labels[this.$i18n.availableLocales[i] + "-GB"] = this.$t("language." + this.$i18n.availableLocales[i]);
						break;
					case "fr":
						labels[this.$i18n.availableLocales[i] + "-FR"] = this.$t("language." + this.$i18n.availableLocales[i]);
						break;
					default:
						labels["en-US"] = this.$t("language.en");
						break;
				}
			}

			return labels;
		}
	}
})

String.prototype.format = function()
{
   var content = this;
   for (var i=0; i < arguments.length; i++)
   {
        var replacement = '{' + i + '}';
        content = content.replace(replacement, arguments[i]); 
   }
   return content;
};

new Vue({
	vuetify,
	i18n,
	data: {
		currentPage: null,
		browser: {
			name: "unknown",
			version: "unknown"
		},
		device: {
			windows: null,
			windowsPhone: null,
			ipod: null,
			ipad: null,
			iphone: null,
			ios: null,
			mac: null,
			android: null,
			androidPhone: null,
			mobile: null
		},
		embeddedLesson: false,
		lessonData: {
			author: "",
			category: "",
			description: "",
			isVideoLesson: false,
			name: "",
			version: "",		// process.env.VUE_APP_VERSION,
			videoPlayerData: null,
			cookies: null,
			chapters: null,
			documents: null,
			organisation: null,
			startTime: null
		},
		modalDialog: {
			content: null,
			showDialog: false,
			title: null
		}
	},
	beforeCreate() {
		Logger.log("main.js beforeCreate");
	},
	created() {
		Logger.log("main.js created");

		// set browser information
		this.setBrowserInfo();

		if (this.browser.name == "msie") { // client is IE, handle CSS variables
			cssVars({
				include: "style,link[data-include]",
				onlyLegacy: true,
				silent: true,
				updateURLs: false,
				preserveStatic: true,
				preserveVars: false,
				watch: true,
				onBeforeSend: function(xhr, elm, url) {
					Logger.log("load from "+url);
				},
				onComplete: function(cssText, styleElms, cssVariables, benchmark) {
					Logger.log("onComplete ", cssText);
					window.jQuery("body").show(); // Main.vue "body" is hidden in beforeMount()
					window.jQuery(window).trigger("resize"); // because in IE the footer covers the bottom of the page when first loaded, see handler in Footer.vue
				},
				onSuccess: function(cssText, node, url) {
					if (url) {
						Logger.log('Success: ' + url + ' (' + cssText.length + ' characters)');
					}
				},
				onError: function(message, elm, xhr, url) {
					Logger.error('Error: ',message, elm, xhr, url);
				}
			});
		}

		// set device properties
		this.setDeviceProperties();
		
		// set the current language
		this.setCurLanguage();

		// load the lesson data
		this.loadLessonData();
	},
	beforeMount() {
		Logger.log("main.js beforeMount");
	},
	mounted() {
		Logger.log("main.js mounted");
	},
	beforeUpdate() {
		Logger.log("main.js beforeUpdate");
	},
	updated() {
		Logger.log("main.js updated");
	},
	beforeDestroy() {
		Logger.log("main.js beforeDestroy");
	},
	destroyed() {
		Logger.log("main.js destroyed");
	},
	methods: {
		getQueryParameter(param) {
			var results = new RegExp("[?&]{0}=([^&#]*)".format(param)).exec(window.location.search),
				val = null;
			if (results) {
				val = results[1] || null;
			}
			return val;
		},
		setCurLanguage() {
			// set language according to browser
			// default language is set in i18n.js
			var curLocale = navigator.language || navigator.browserLanguage,
				supportedLanguages = this.$i18n.availableLocales;
				//supportedLanguages = this.$getConst("SUPPORTED_LANGUAGES");
			if (curLocale && supportedLanguages) {
				curLocale = curLocale.toLowerCase();
				for (var i= 0; i < supportedLanguages.length; i++) {
					if (curLocale.indexOf(supportedLanguages[i]) == 0) {
						this.$i18n.locale = supportedLanguages[i];
						break;
					}
				}
			}
		},
		setBrowserInfo() {
			// set the browser information
			if (window.navigator && window.navigator.userAgent) {
				var input, result, userAgent = window.navigator.userAgent.toLowerCase();
				/**** Edge ****/
				if (userAgent.indexOf("edge/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("edge/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "edge";
						this.browser.version = splits[1];
					}
				}
				/**** Opera ****/
				else if (userAgent.indexOf("opr/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opr/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera/") !== -1 && userAgent.indexOf("version/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("version/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera ") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opera ")),
						splits = substring.split(" ");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opera/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				/**** Chrome ****/
				else if (userAgent.indexOf("chrome/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("chrome/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "chrome";
						this.browser.version = splits[1];
					}
				}
				/**** Safari ****/
				else if (userAgent.indexOf("safari/") !== -1 && userAgent.indexOf("version/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("version/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "safari";
						this.browser.version = splits[1];
					}
				}
				/**** Firefox ****/
				else if (userAgent.indexOf("firefox/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("firefox/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "firefox";
						this.browser.version = splits[1];
					}
				}
				/**** Internet Explorer ****/
				else if (result = userAgent.match(/\(([^()]+)\)/)) { // first substring within parentheses
					input = result[0];
					if (input.indexOf("trident/") !== -1 && input.indexOf("rv:11") !== -1) { // IE 11
						this.browser.name = "msie";
						this.browser.version = "11";
					}
					else if (input.indexOf("msie ") !== -1) { // IE 10 and older
						var substring = input.substring(input.indexOf("msie ")).split(";")[0],
							splits = substring.split(" ");
						if (splits && splits.length > 1) {
							this.browser.name = "msie";
							this.browser.version = splits[1];
						}
					}
				}
			}
		},
		setDeviceProperties() {
			// set device properties
			if (window.navigator && window.navigator.userAgent) {
				var userAgent = window.navigator.userAgent.toLowerCase();
				this.device.windows = userAgent.indexOf("windows") !== -1;
				this.device.windowsPhone = this.device.windows && userAgent.indexOf("mobile") !== -1;
				this.device.ipod = userAgent.indexOf("ipod") !== -1;
				this.device.ipad = userAgent.indexOf("ipad") !== -1 && userAgent.indexOf("webkit") !== -1;
				this.device.iphone = !this.device.windows && userAgent.indexOf("iphone") !== -1 && !this.device.ipad && !this.device.ipod;
				this.device.ios = this.device.iphone || this.device.ipad || this.device.ipod;
				this.device.mac = userAgent.indexOf("macintosh") !== -1;
				this.device.android = userAgent.indexOf("android") !== -1;
				this.device.androidPhone = this.device.android && userAgent.indexOf("mobile") !== -1;
				this.device.mobile = this.device.androidPhone || this.device.iphone || this.device.ipod || this.device.windowsPhone;
			}
		},
		loadLessonData() {
			var encLink = null,
				qParam = "enc";
			// read query string parameter 'play'
			if (encLink = this.getQueryParameter("play")) {
				this.embeddedLesson = true;
				qParam = "play";
			}
			// read query string parameter 'enc'
			else if (encLink = this.getQueryParameter("enc")) {
				this.embeddedLesson = false;
			}

			if (encLink) {
				//var url = "http://localhost:8080/portal-videolearning/restcors/common/decryptLink?enc=D%2Ftrnjzgg9dW7Jg21udPdA5DXKwoe5Z0mrcM%2FAPAlm%2FAvpwFLlPBvG86IdGLJlyk";
				//var url = "http://localhost:8080/portal-videolearning/restcors/common/decryptLink?enc=MV0Lr%2FridbOTjg03o1tBJKTAnlRlyBG3m9DvnbevWzbQt6DA%2FQveH9c74glsVpZB";
				//var url = "http://local.video2know.com:8080/portal-videolearning/rest/lesson/lessonData?enc=MV0Lr%2FridbOTjg03o1tBJKTAnlRlyBG3m9DvnbevWzbQt6DA%2FQveH9c74glsVpZB";
				var url = "{0}?{1}={2}".format(process.env.VUE_APP_LESSONDATA_SERVICE_URL, qParam, encLink);
				window.jQuery.ajax(url, {
					dataType: "json",
					//headers: { "Authorization": "Basic " + btoa("video2know|greg.may@eurobase.lu:TestDev1") }
				}).done((json) => {
					Logger.log("success");
					//Logger.log(json);
					// check object state
					if (json.state.toLowerCase() === "okay") {

						// set window title
						var title;
						if (json.data.category) {
							title = json.data.category[this.$i18n.locale] || json.data.category["en"];
						}
						document.title = title || this.$t("windowTitle");

						// everything okay, assign lesson data
						window.jQuery.extend(this.lessonData, json.data);

						// is video lesson?
						if (json.data.videoPlayerData) {
							this.lessonData.isVideoLesson = true;
							this.lessonData.startTime = parseInt(this.getQueryParameter("startTime")) || null;

							// add icon property to chapters array
							if (this.lessonData.chapters) {
								for (var i=0; i < this.lessonData.chapters.length; i++) {
									this.lessonData.chapters[i].icon = 0;
								}
							}
						}

						// add skin files
						if (this.lessonData.organisation) {
							// default
							if (this.lessonData.organisation.defaultSkinUrl) {
								window.jQuery("head title").last().after(
									window.jQuery("<link/>", {
										rel: "stylesheet",
										type: "text/css",
										"data-include": "",
										href: "{0}?v={1}".format(this.lessonData.organisation.defaultSkinUrl, this.lessonData.version)
										//href: "https://res-app.dev.video2know.com/organisation/skin/default.css?v=8.12.1"
									})
								);
							}
							// organisation
							if (this.lessonData.organisation.skinUrl) {
								window.jQuery("head link[rel='stylesheet']").last().after(
									window.jQuery("<link/>", {
										rel: "stylesheet",
										type: "text/css",
										"data-include": "",
										href: "{0}?v={1}".format(this.lessonData.organisation.skinUrl, this.lessonData.version)
										//href: "https://res-app.dev.video2know.com/organisation/skin/gregstestorg.css?v=8.12.1"
									})
								);
							}
						}
						
						if (this.embeddedLesson) {
							// show embedded lesson
							this.currentPage = this.$getConst("EMBEDDED_PAGE");
						}
						else {
							// show lesson page
							this.currentPage = this.$getConst("LESSON_PAGE");
						}
					}
					else {
						var error = "GET lessonData service return state '{0}':  {1}".format(json.state, json.msgCode);
						Logger.error("exception occurred:\n\t" + error, "url: " + url);
						if (json.msgCode === "rsError") {
							// show error page
							this.currentPage = this.$getConst("ERROR_PAGE");
						}
						else {
							// show HTTP Status Code 404 page
							this.currentPage = this.$getConst("STATUS_404_PAGE");
						}
					}
				}).fail((jqxhr, textStatus, error) => {
					var msg = "error (status code {0}): ".format(jqxhr.status);
					switch (jqxhr.status) {
						case 0:
							msg += "network/connection error";
							break;
						default:
							if (textStatus) {
								msg += textStatus;
								if (error)
									msg += ", " + error;
							}
							else if (error) {
								msg += error;
							}
							break;
					}
					Logger.error(msg);
					// show error page
					this.currentPage = this.$getConst("ERROR_PAGE");
				}).always(function() {
					Logger.log("complete");
				});
			}
			else {
				// show HTTP Status Code 404 page
				this.currentPage = this.$getConst("STATUS_404_PAGE");
			}
		}
	},
	render: h => h(App)
}).$mount('#app')
